import './ShiningTitle.css';	

export default function ShiningTitle () {
	return (
		<div className="title">HELLOWIZZ</div>
	)
}